import React from "react";

/**
 * Hubinall "H" mark — exact SVG geometry from the source file
 * (h_logo_footer_refined_v6_thinner_closer.svg, 1000×1000 viewBox).
 *
 * Outer frame: left / top / bottom solid.
 * Right edge: two segments (y=194..360 and y=640..806); middle is open.
 * Inner H: two vertical bars and a crossbar at y=484..516.
 * All elements are 32px-wide rectangles (sharp corners, uniform weight).
 *
 * `fill` accepts a CSS color or `url(#grad-id)` for gradient fills.
 */
export default function Logo({ size = 28, fill = "currentColor", className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 1000 1000"
      className={className}
      aria-label="Hubinall logo"
      data-testid="hubinall-logo"
    >
      <g fill={fill}>
        {/* Outer frame */}
        <rect x="304" y="194" width="32" height="612" />
        <rect x="304" y="194" width="372" height="32" />
        <rect x="304" y="774" width="372" height="32" />
        {/* Right edge split */}
        <rect x="644" y="194" width="32" height="166" />
        <rect x="644" y="640" width="32" height="166" />
        {/* Inner H */}
        <rect x="424" y="360" width="32" height="280" />
        <rect x="596" y="360" width="32" height="280" />
        <rect x="424" y="484" width="204" height="32" />
      </g>
    </svg>
  );
}
